(function () {
  'use strict';

  if (window.PGPreserveCartCloseV1) return;
  window.PGPreserveCartCloseV1 = true;

  var savedClose = null;
  var restoreTimer = null;
  var observer = null;

  function cartContent() {
    return document.querySelector('.cart_content');
  }

  function nativeClose(content) {
    if (!content) return null;
    return content.querySelector('.pg-drawer-close, [data-cart-close], [data-cart-drawer-close], [aria-label="Close cart"]');
  }

  function remember() {
    var content = cartContent();
    var close = nativeClose(content);
    if (close) savedClose = close;
    return close;
  }

  function restore() {
    window.clearTimeout(restoreTimer);
    restoreTimer = null;

    var content = cartContent();
    if (!content) return;

    var existing = nativeClose(content);
    if (existing) {
      savedClose = existing;
      return;
    }

    if (savedClose) {
      content.insertBefore(savedClose, content.firstChild);
    }
  }

  function scheduleRestore(delay) {
    window.clearTimeout(restoreTimer);
    restoreTimer = window.setTimeout(function () {
      remember();
      restore();
    }, delay == null ? 0 : delay);
  }

  function observe() {
    if (!window.MutationObserver || observer) return;

    observer = new MutationObserver(function () {
      var content = cartContent();
      if (!content) return;

      var close = nativeClose(content);
      if (close) {
        savedClose = close;
        return;
      }

      if (savedClose) scheduleRestore(0);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    remember();
    observe();

    document.addEventListener('click', function () {
      window.setTimeout(remember, 0);
      window.setTimeout(restore, 120);
    }, true);

    document.addEventListener('cart:refresh', function () {
      scheduleRestore(0);
      scheduleRestore(150);
    });

    if (window.jQuery) {
      window.jQuery(document).on('cart.requestComplete', function () {
        scheduleRestore(0);
        scheduleRestore(150);
      });
    }

    window.addEventListener('pageshow', function () {
      scheduleRestore(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
